import BaseTracker from './base-tracker';

export default class ErrorTracker extends BaseTracker {
  start() {
    this._player.addEventListener('error', this._onError);
  }

  _onError = () => {
    this._track();
  };

  stop() {
    this._player.removeEventListener('error', this._onError);
  }
}
